import { render } from "./openTaskComp.vue?vue&type=template&id=4b912084"
import script from "./openTaskComp.vue?vue&type=script&lang=js"
export * from "./openTaskComp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__